export const getOrderShortCode = (order: {
  shortCode?: string | number;
  id: number;
}) => (order.shortCode ?? order.id).toString();

export const getReadyTime = (
  createdAt?: Date | string | null,
  minutesToReady = 5,
  locale: string = 'ru-RU'
): string => {
  if (!createdAt) return '';

  const ts =
    createdAt instanceof Date
      ? createdAt.getTime()
      : new Date(createdAt).getTime();

  if (Number.isNaN(ts)) return '';

  const ready = new Date(ts + minutesToReady * 60 * 1000);
  return ready.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });
};
